import Button from './button';

import Arrow from './arrow';

export default function ButtonReturn(props) {
    const { children, leftIcon = null, rightIcon = null } = props;

    let data = {}

    if (rightIcon !== null) {
        data.rightIcon = rightIcon;
    } else {
        data.leftIcon = leftIcon || <Arrow rotate={'90deg'}/> ;
    }

    return <Button { ...props } className="button--cancel" { ...data }>{ children ? children : 'Return' }</Button>
}